import clsx from "clsx"
import { NpIcon } from "src/components/np-design/components/NpIcon"
import { A } from "src/components/unstyled/A"
import { routes } from "src/config/routes"

export type NpLogoProps = {
  className?: string
}

export const NpLogo = ({ className }: NpLogoProps) => {
  return (
    <A href={routes.home} title="Startseite" aria-label="Startseite" className="rounded-lg">
      <NpIcon name="logo_panorama" aria-label="Elvent Logo" className={clsx(className, "pb-1")} />
    </A>
  )
}
